import React, { useCallback, useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";
import Card from "../Reusablecomponents/Card";
import BackButton from "../Reusablecomponents/BackButton";
import ToastPopup from "../popups/ToastPopup";
import RescheduleMeetingPopup from "../popups/RescheduleMeetingPopup";
import "../css/others/Table.css";
import "../css/others/Card.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import IconComponent from "../Reusablecomponents/IconComponent";
import { ICampaignDetailsInfo, IAuditor, IChecklistItem, RescheduleData, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import EncryptionUtils from "../main/encryptionUtils";
const CampaignDetailsInfo: React.FC = () => {
  const [campaign, setCampaign] = useState<ICampaignDetailsInfo | null>(null);
  const [originalCampaign, setOriginalCampaign] = useState<ICampaignDetailsInfo | null>(null);
  const [, setAuditorList] = useState<IAuditor[]>([]);
  const [activeAuditors, setActiveAuditors] = useState<IAuditor[]>([]);
  const [, setChecklistOptions] = useState<IChecklistItem[]>([]);
  const [integratedChecklists, setIntegratedChecklists] = useState<IChecklistItem[]>([]);
  const [normalChecklists, setNormalChecklists] = useState<IChecklistItem[]>([]);
  const [filteredNormalChecklists, setFilteredNormalChecklists] = useState<IChecklistItem[]>([]);
  const [filteredIntegratedChecklists, setFilteredIntegratedChecklists] = useState<IChecklistItem[]>([]);
  const [editableFields, setEditableFields] = useState<string[]>([]);
  const [isEditing, setIsEditing] = useState(false);
  const [remark, setRemark] = useState("");
  const [showReschedulePopup, setShowReschedulePopup] = useState(false);
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [actionType, setActionType] = useState<'INCLUDE' | 'EXCLUDE' | null>(null);
  const [showIncludeConfirmation, setShowIncludeConfirmation] = useState(false);
  const [showExcludeConfirmation, setShowExcludeConfirmation] = useState(false);
  const { projectId, campaignId } = useParams<{ projectId: string; campaignId: string }>();
  const location = useLocation();
  const campaignStatus = location.state?.campaignStatus;
  const { roleName, userRole } = EncryptionUtils.getAuthInfo();
  const clientId = localStorage.getItem("clientId");
  const providerId = localStorage.getItem("providerId");
  const userEmail = localStorage.getItem("email");
  const updatedBy = localStorage.getItem("email");
  const [, setAuditorRoleId] = useState<string>("");
  const [campaignQcReviewDuration, setCampaignQcReviewDuration] = useState<number>(0);
  const [campaignStartDate, setCampaignStartDate] = useState<string | null>(null);
  const restrictedChars = /[\\:*?"<>|/]/;
  const includedFields = ["campaignName", "campaignId", "accountId", "accountName", "businessUnit", "projectId", "projectName", "projectManagerName", "deliveryManagerName", "deliveryHeadName", "teamSize", "deliveryModel", "billingType", "qualityConsultantName", "qualityManagerName", "estimationModel", "devOps_CICDtoolname", "testingToolName", "codequalityToolName", "testManagerName", "architect", "technicalLeadName", "customerLocation", "projectLocation", "projectLifeCycle", "risk", "targetML", "remarkByQC", "remarkByAuditTeam", "createdDate", "createdBy", "projectStartDate", "projectEndDate", "projectManagerEmail", "deliveryManagerEmail", "deliveryHeadEmail", "qualityConsultantEmail", "qualityManagerEmail", "testManagerEmail", "technicalLeadEmail", "auditorEmployeeId", "primaryAuditorName", "secondaryAuditorName", "campaignStartDate", "campaignEndDate", "assignedCheckList", "updatedDate", "remarkByAdmin", "updatedBy"];
  const getCommonPayloadFields = () => {
    return {
      providerId, loggedInEmail: userEmail
    };
  };
  const getEditableFields = useCallback((): string[] => {
    const userRole = roleName;
    const itemStatus = campaign?.itemStatus;
    const auditStatus = campaign?.auditStatus;
    if (auditStatus !== "NOT_STARTED") return [];
    if (itemStatus !== "AUTO_INCLUDED" && itemStatus !== "FINAL_INCLUDED") return [];
    const baseEditableFields = ["remarkByQC", "remarkByAdmin", "actualML", "primaryAuditorName", "secondaryAuditorName", "assignedCheckList"];
    if (userRole === 'Quality Consultant') return ["remarkByQC"];
    if (["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(userRole || ""))
      return baseEditableFields.filter(field => field !== "remarkByQC");
    return [];
  }, [campaign?.itemStatus, campaign?.auditStatus, roleName]);
  useEffect(() => {
    const fetchClientConfig = async () => {
      try {
        const response = await apiCall("get", `/api/client-config/${clientId}`);
        setCampaignQcReviewDuration(response?.campaignQcReviewDuration || 0);
      } catch (error) {
        console.error("Error fetching client config:", error);
      }
    };
    if (clientId) {
      fetchClientConfig();
    }
  }, [clientId]);
  const getFilteredAuditorsByCampaignType = useCallback((): { primaryAuditors: IAuditor[], secondaryAuditors: IAuditor[] } => {
    if (!campaign) return { primaryAuditors: [], secondaryAuditors: [] };
    const auditType = campaign.auditType;
    const auditScopeControls: string[] = campaign.auditScopeControls || [];
    const typeMatchedAuditors = activeAuditors.filter((auditor: IAuditor) =>
      auditor.auditorType === auditType && auditor.userStatus === "ACTIVE"
    );
    let filteredAuditors = typeMatchedAuditors;
    if (auditScopeControls.length > 0) {
      filteredAuditors = typeMatchedAuditors.filter((auditor: IAuditor) => {
        if (!auditor.skills || auditor.skills.length === 0) return false;
        return auditScopeControls.some((control: string) => {
          const normalizedControl = control.toUpperCase().replace(/\s/g, '_');
          const normalizedSkills = auditor.skills!.map((skill: string) =>
            skill.toUpperCase().replace(/\s/g, '_')
          );
          return normalizedSkills.some((skill: string) =>
            skill.includes(normalizedControl) || normalizedControl.includes(skill)
          );
        });
      });
    }
    if (filteredAuditors.length === 0) {
      return { primaryAuditors: [], secondaryAuditors: [] };
    }
    const primaryAuditors = filteredAuditors.filter((a: IAuditor) => a.isPrimaryAuditor);
    const secondaryAuditors = filteredAuditors.filter((a: IAuditor) => !a.isPrimaryAuditor);
    return { primaryAuditors, secondaryAuditors };
  }, [campaign, activeAuditors]);
  const isChecklistAssigned = () => {
    return campaign?.assignedCheckList && campaign.assignedCheckList.trim() !== "";
  };
  const isPrimarySelected = () => {
    return campaign?.primaryAuditorName &&
      campaign.primaryAuditorName.trim() !== "";
  };
  const extractEmailFromAuditorName = (auditorName: string): string => {
    if (!auditorName) return '';
    const emailMatch = auditorName.match(/\(([^)]+)\)/);
    return emailMatch ? emailMatch[1] : auditorName;
  };
  const getAuditorDisplayName = (auditor: IAuditor): string => {
    return `${auditor.name}`;
  };
  const findAuditorByEmail = (email: string): IAuditor | undefined => {
    return activeAuditors.find(auditor => {
      const auditorEmail = extractEmailFromAuditorName(auditor.name);
      return auditorEmail === email;
    });
  };
  const filterChecklistsByAuditScope = (normalChecklists: IChecklistItem[], integratedChecklists: IChecklistItem[], auditScope: string | undefined, auditScopeControls: string[] | undefined) => {
    if (auditScopeControls && auditScopeControls.length > 0) {
      const filteredIntegrated = integratedChecklists.filter(checklist => {
        if (checklist.controls && Array.isArray(checklist.controls)) {
          return checklist.controls.some(control =>
            auditScopeControls.includes(control)
          );
        }
        return auditScopeControls.some(control =>
          checklist.templateName?.toLowerCase().includes(control.toLowerCase()) ||
          checklist.baseTemplateId?.toLowerCase().includes(control.toLowerCase())
        );
      });
      return { normal: [], integrated: filteredIntegrated };
    }
    if (auditScope && auditScope.trim() !== "") {
      const filteredNormal = normalChecklists.filter(checklist => {
        return checklist.templateName?.toLowerCase().includes(auditScope.toLowerCase()) ||
          checklist.baseTemplateId?.toLowerCase().includes(auditScope.toLowerCase());
      });
      return { normal: filteredNormal, integrated: [] };
    }
    return { normal: normalChecklists, integrated: [] };
  };
  useEffect(() => {
    if (!projectId || !campaignId) {
      setError("Project ID or Campaign ID is missing.");
      return;
    }
    apiCall("get", `/api/campaign-projects?campaignId=${campaignId}&projectId=${projectId}`)
      .then((response) => {
        if (response) {
          setCampaign(response);
          setOriginalCampaign(response);
          if (response.campaignStartDate) {
            setCampaignStartDate(response.campaignStartDate);
          }
        }
      })
      .catch((error) => console.error("Error fetching campaign details:", error));
    apiCall("get", `/api/roles/all/${clientId}`)
      .then((roles) => {
        const auditorRole = roles.find((role: any) => role.name === "Auditor");
        if (auditorRole) {
          setAuditorRoleId(auditorRole.id);
          return apiCall("get", `/api/users/names?clientId=${clientId}`, null, { roleId: auditorRole.id });
        }
        throw new Error("Auditor role not found");
      })
      .then((response) => {
        const auditors: IAuditor[] = response.map((a: any) => ({ id: a.id, name: a.name, isPrimaryAuditor: a.isPrimaryAuditor, userStatus: a.userStatus || "ACTIVE", skills: a.skills || [], auditorType: a.auditorType || null }));
        setAuditorList(auditors);
        const activeAuditorsList = auditors.filter((auditor: IAuditor) => auditor.userStatus === "ACTIVE");
        setActiveAuditors(activeAuditorsList);
      })
      .catch((error) =>
        console.error("Error fetching roles or auditors:", error));
    apiCall("get", `/api/local-templates?clientId=${clientId}&status=ACTIVE`)
      .then((response) => {
        const checklists = response.content || [];
        setChecklistOptions(checklists);
        const integrated = checklists.filter((item: IChecklistItem) => item.isIntegratedChecklist);
        const normal = checklists.filter((item: IChecklistItem) => !item.isIntegratedChecklist);
        setIntegratedChecklists(integrated);
        setNormalChecklists(normal);
      })
      .catch((error) => console.error("Error fetching checklist options:", error));
  }, [projectId, campaignId, clientId]);
  useEffect(() => {
    if (campaign && (normalChecklists.length > 0 || integratedChecklists.length > 0)) {
      const { normal: filteredNormal, integrated: filteredIntegrated } = filterChecklistsByAuditScope(normalChecklists, integratedChecklists, campaign.auditScope, campaign.auditScopeControls);
      setFilteredNormalChecklists(filteredNormal);
      setFilteredIntegratedChecklists(filteredIntegrated);
    }
  }, [campaign, normalChecklists, integratedChecklists]);
  useEffect(() => {
    if (campaign) {
      setEditableFields(getEditableFields());
    }
  }, [campaign, getEditableFields]);
  const handleRescheduleMeeting = () => setShowReschedulePopup(true);
  const handleCloseReschedulePopup = () => setShowReschedulePopup(false);
  const handleRescheduleSubmit = async (data: RescheduleData) => {
    if (!userEmail) {
      setMessage(createToastMessage("User email not found.", "warning", 3000));
      return;
    }
    const payload = { eventId: data.eventId, newStartTime: data.newStartTime, newEndTime: data.newEndTime, timezone: data.timezone, updatedAttendees: data.updatedAttendees, sendUpdates: "all", rescheduledBy: userEmail, loggedInEmail: userEmail };
    try {
      await apiCall("post", "/api/meetings/reschedule", payload);
      setMessage(createToastMessage("Meeting rescheduled successfully.", "success", 2800));
      setShowReschedulePopup(false);
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to reschedule meeting";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleEdit = () => setIsEditing(true);
  const handleSaveChecklistOnly = async () => {
    if (!campaign || !campaignId || !projectId) return;
    if (!campaign.assignedCheckList?.trim()) {
      setMessage(createToastMessage("Please select a checklist to assign.", "warning", 3000));
      return;
    }
    const payload: any = { campaignId, projectId, assignedCheckList: campaign.assignedCheckListId, updatedBy };
    try {
      await apiCall("patch", "/api/campaign-projects", payload);
      setMessage(createToastMessage("Checklist assigned successfully!", "success", 3000));
      const response = await apiCall("get", `/api/campaign-projects?campaignId=${campaignId}&projectId=${projectId}`);
      if (response) {
        setCampaign(response);
        setOriginalCampaign(response);
      }
      setIsEditing(false);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to assign checklist";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleSaveAuditorsOnly = async () => {
    if (!campaign || !originalCampaign || !campaignId || !projectId) return;
    if (!campaign.primaryAuditorName?.trim()) {
      setMessage(createToastMessage("Primary Auditor is required.", "warning", 3000));
      return;
    }
    const payload: any = { campaignId, projectId, ...getCommonPayloadFields(), updatedBy };
    let hasChanges = false;
    if (campaign.primaryAuditorName !== originalCampaign.primaryAuditorName) {
      payload.primaryAuditorName = campaign.primaryAuditorName;
      hasChanges = true;
    }
    if (campaign.secondaryAuditorName !== originalCampaign.secondaryAuditorName) {
      payload.secondaryAuditorName = campaign.secondaryAuditorName;
      hasChanges = true;
    }
    if (!hasChanges) {
      setMessage(createToastMessage("No changes detected in auditor assignments.", "warning", 3000));
      return;
    }
    try {
      await apiCall("patch", "/api/campaign-projects", payload);
      setMessage(createToastMessage("Auditors assigned successfully!", "success", 3000));
      const response = await apiCall("get", `/api/campaign-projects?campaignId=${campaignId}&projectId=${projectId}`);
      if (response) {
        setCampaign(response);
        setOriginalCampaign(response);
      }
      setIsEditing(false);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to assign auditors";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleSaveAll = async () => {
    if (!campaign || !originalCampaign || !campaignId || !projectId) return;
    if (editableFields.includes('remarkByQC') && !campaign.remarkByQC?.trim()) {
      setMessage(createToastMessage("Remark by QC cannot be empty.", "warning", 3000));
      return;
    }
    const payload: any = { campaignId, projectId, ...getCommonPayloadFields(), updatedBy };
    let hasChanges = false;
    for (const key of editableFields) {
      if (campaign[key] !== originalCampaign[key]) {
        if (key === 'remarkByQC' && !campaign[key]?.trim()) continue;
        if (key === 'assignedCheckList') {
          payload['assignedCheckList'] = campaign['assignedCheckListId'];
        }
        else if (key === 'primaryAuditorName') {
          payload['primaryAuditorName'] = campaign['primaryAuditorName'];
        }
        else if (key === 'secondaryAuditorName') {
          payload['secondaryAuditorName'] = campaign['secondaryAuditorName'];
        }
        else {
          payload[key] = campaign[key];
        }
        hasChanges = true;
      }
    }
    if (!hasChanges) {
      setMessage(createToastMessage("No changes detected.", "warning", 3000));
      setIsEditing(false);
      return;
    }
    try {
      await apiCall("patch", "/api/campaign-projects", payload);
      setMessage(createToastMessage("Changes saved successfully!", "success", 3000));
      const response = await apiCall("get", `/api/campaign-projects?campaignId=${campaignId}&projectId=${projectId}`);
      if (response) {
        setCampaign(response);
        setOriginalCampaign(response);
      }
      setIsEditing(false);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || "Failed to save changes";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleSave = () => {
    const hasChecklistChange = campaign?.assignedCheckList !== originalCampaign?.assignedCheckList;
    const hasAuditorChanges = campaign?.primaryAuditorName !== originalCampaign?.primaryAuditorName || campaign?.secondaryAuditorName !== originalCampaign?.secondaryAuditorName;
    const hasOtherChanges = editableFields.some(key => {
      if (key === 'assignedCheckList' || key === 'primaryAuditorName' || key === 'secondaryAuditorName')
        return false;
      return campaign?.[key] !== originalCampaign?.[key];
    });
    if (hasChecklistChange && !isChecklistAssigned() && !hasAuditorChanges && !hasOtherChanges) {
      handleSaveChecklistOnly();
    }
    else if (hasAuditorChanges && isChecklistAssigned() && !hasChecklistChange && !hasOtherChanges) {
      handleSaveAuditorsOnly();
    }
    else {
      handleSaveAll();
    }
  };
  const handleCancel = () => {
    if (originalCampaign) {
      setCampaign({ ...originalCampaign });
    }
    setIsEditing(false);
  };
  const handleExcludeProjects = async () => {
    if (!campaignId || !projectId || !campaign) {
      setMessage(createToastMessage("Project ID or Campaign ID is missing", "error", 3000));
      return;
    }
    try {
      await apiCall("patch", `/api/campaign-projects/status/${campaignId}`, { itemStatus: "ADMIN_REVIEW", status: 'EXCLUDED', projectIds: [projectId], remark: remark.trim() || campaign.remarkByQC });
      setMessage(createToastMessage('Project excluded successfully!', "success", 3000));
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error.message || "Failed to exclude project";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleIncludeProjects = async () => {
    if (!campaignId || !projectId || !campaign) {
      setMessage(createToastMessage("Project ID or Campaign ID is missing", "error", 3000));
      return;
    }
    try {
      await apiCall("patch", `/api/campaign-projects/status/${campaignId}`, { itemStatus: "ADMIN_REVIEW", status: 'INCLUDED', projectIds: [projectId], remark: remark.trim() || campaign.remarkByQC });
      setMessage(createToastMessage('Project included successfully!', "success", 3000));
      setTimeout(() => window.location.reload(), 3000);
    } catch (error: any) {
      const errorMessage = error?.response?.data?.message || error.message || "Failed to include project";
      setMessage(createToastMessage(errorMessage, "error", 3000));
    }
  };
  const handleFieldChange = (key: string, value: any) => {
    if (!campaign) return;
    if (key === 'primaryAuditorName') {
      const selectedAuditor = activeAuditors.find(auditor => getAuditorDisplayName(auditor) === value);
      const email = selectedAuditor ? extractEmailFromAuditorName(selectedAuditor.name) : value;
      setCampaign({ ...campaign, [key]: email, primaryAuditorId: selectedAuditor?.id || '', ...(value === campaign.secondaryAuditorName ? { secondaryAuditorName: '', secondaryAuditorId: '' } : {}) });
    }
    else if (key === 'secondaryAuditorName') {
      const selectedAuditor = activeAuditors.find(auditor => getAuditorDisplayName(auditor) === value);
      const email = selectedAuditor ? extractEmailFromAuditorName(selectedAuditor.name) : value;
      setCampaign({ ...campaign, [key]: email, secondaryAuditorId: selectedAuditor?.id || '' });
    }
    else if (key === 'assignedCheckList') {
      const selectedTemplate = [...filteredNormalChecklists, ...filteredIntegratedChecklists].find(item => item.templateName === value);
      setCampaign({ ...campaign, [key]: value, assignedCheckListId: selectedTemplate?.baseTemplateId || '' });
    }
    else {
      setCampaign({ ...campaign, [key]: value });
    }
  };
  const openIncludeConfirmation = () => {
    setActionType('INCLUDE');
    setShowIncludeConfirmation(true);
    setRemark("");
  };
  const openExcludeConfirmation = () => {
    setActionType('EXCLUDE');
    setShowExcludeConfirmation(true);
    setRemark("");
  };
  const confirmAction = () => {
    if (!remark.trim()) {
      setMessage(createToastMessage("Please provide comments before confirming.", "warning", 3000));
      return;
    }
    if (actionType === 'EXCLUDE') {
      handleExcludeProjects();
    } else {
      handleIncludeProjects();
    }
    setShowIncludeConfirmation(false);
    setShowExcludeConfirmation(false);
  };
  if (error) {
    return (
      <div className="container">
        <div className="inner-container">
          <h2 className="title">Project Details Information</h2>
        </div>
      </div>
    );
  }
  const canShowProjectActionButtons = () => {
    if (!campaignStartDate || !campaignQcReviewDuration) return false;
    const startDate = new Date(campaignStartDate);
    const visibleFromDate = new Date(startDate);
    visibleFromDate.setDate(startDate.getDate() - campaignQcReviewDuration);
    const currentDate = new Date();
    startDate.setHours(0, 0, 0, 0);
    visibleFromDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    return currentDate >= visibleFromDate && currentDate <= startDate;
  };
  const isAdminOrQC = userRole === 'Admin' || userRole === 'Quality Consultant' || userRole === 'Primary Spoc' || userRole === 'Secondary Spoc' || userRole === 'Super Admin';
  const showIncludeExcludeButtons = roleName === "Quality Consultant" && campaign?.itemStatus === "QC_REVIEW" && campaignStatus === "NOT_STARTED";
  const isCampaignClosed = campaignStatus === "CLOSED";
  const displayFields = campaign ? Object.entries(campaign).filter(([key]) => includedFields.includes(key)) : [];
  const { primaryAuditors: availablePrimaryAuditors, secondaryAuditors: availableSecondaryAuditors } = getFilteredAuditorsByCampaignType();
  const getCurrentPrimaryAuditorName = () => {
    if (!campaign?.primaryAuditorName) return '';
    const auditor = findAuditorByEmail(campaign.primaryAuditorName);
    return auditor ? getAuditorDisplayName(auditor) : '';
  };
  const getCurrentSecondaryAuditorName = () => {
    if (!campaign?.secondaryAuditorName) return '';
    const auditor = findAuditorByEmail(campaign.secondaryAuditorName);
    return auditor ? getAuditorDisplayName(auditor) : '';
  };
  const handleRestrictedTextareaChange = (value: string, setter: React.Dispatch<React.SetStateAction<string>>) => {
    if (restrictedChars.test(value)) {
      setMessage(createToastMessage(`Special characters are not allowed - ${restrictedChars}`, "warning", 3000));
      return;
    }
    setter(value);
  };
  const getFilteredChecklistsForDisplay = () => {
    const combined = [...filteredNormalChecklists, ...filteredIntegratedChecklists];
    if (combined.length === 0 && (filteredNormalChecklists.length === 0 && filteredIntegratedChecklists.length === 0)) {
      return [];
    }
    return combined;
  };
  const hasAvailableAuditors = (): boolean => {
    return availablePrimaryAuditors.length > 0 || availableSecondaryAuditors.length > 0;
  };
  return (
    <div className="container">
      <div className="inner-container">
        <h2 className="title">Project Details Information</h2>
        <div className="button-group">
          {!campaign ? (
            <p className="loading">Loading campaign details...</p>
          ) : (
            <>
              {roleName && ["Admin", "Primary Spoc", "Secondary Spoc", "Super Admin"].includes(roleName) && campaign.isMeetingScheduled && campaign.auditStatus === "NOT_STARTED" && !isCampaignClosed && (
                <button className="reschedule-meeting" onClick={handleRescheduleMeeting}> Reschedule Meeting</button>
              )}
              {campaignStatus === "NOT_STARTED" && showIncludeExcludeButtons && canShowProjectActionButtons() && (
                <>
                  <button className="save" onClick={openIncludeConfirmation}> Include projects</button>
                  <button className="cancel" onClick={openExcludeConfirmation}> Exclude projects</button>
                </>
              )}
              {isEditing ? (
                <>
                  <button className="save" onClick={handleSave}>Save</button>
                  <button className="cancel" onClick={handleCancel}>Cancel</button>
                </>
              ) : (isAdminOrQC && editableFields.length > 0 && !isCampaignClosed && campaign.auditStatus === "NOT_STARTED" &&
                (campaign.itemStatus === "AUTO_INCLUDED" || campaign.itemStatus === "FINAL_INCLUDED") && (
                  <button className="edit" onClick={handleEdit}>Edit</button>
                )
              )}
            </>
          )}
        </div>
      </div>
      {campaign && (
        <div className="grid">
          {isCampaignClosed ? (
            displayFields.map(([key, value]) => (
              <Card key={key} label={key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())} value={value || "N/A"} icon={<IconComponent name={key} className="icon" />} />
            ))
          ) : (
            <>
              {(isAdminOrQC &&
                editableFields.length > 0 && campaign.auditStatus === "NOT_STARTED" &&
                (campaign.itemStatus === "AUTO_INCLUDED" || campaign.itemStatus === "FINAL_INCLUDED")) && (
                  <h3 className="editfield">Editable Fields</h3>
                )}
              {isAdminOrQC && campaign.auditStatus === "NOT_STARTED" && editableFields
                .filter(key => includedFields.includes(key))
                .map((key) => {
                  const value = campaign[key];
                  const label = key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase());
                  const isAuditorFieldDisabled = (key === 'primaryAuditorName' && !isChecklistAssigned()) || (key === 'secondaryAuditorName' && (!isChecklistAssigned() || !isPrimarySelected()));
                  const filteredChecklists = getFilteredChecklistsForDisplay();
                  const showNoChecklistsMessage = filteredChecklists.length === 0 && (campaign.auditScopeControls && campaign.auditScopeControls.length > 0 ? "No integrated checklists match the audit scope controls" : campaign.auditScope ? "No normal checklists match the audit scope" : "No checklists available");
                  const showNoAuditorsMessage = (key === 'primaryAuditorName' || key === 'secondaryAuditorName') && !hasAvailableAuditors() && isEditing;
                  return (
                    <Card key={key} label={label} value={isEditing ?
                      (key === 'primaryAuditorName' ? (
                        showNoAuditorsMessage ? (
                          <div className="no-data">No {campaign?.auditType} auditors available with matching skills</div>
                        ) : (
                          <select value={getCurrentPrimaryAuditorName()} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input" disabled={isAuditorFieldDisabled} title={isAuditorFieldDisabled ? "Please save the checklist first before assigning auditors" : ""}>
                            <option value="">Select Primary Auditor</option>
                            {availablePrimaryAuditors.length > 0 && availablePrimaryAuditors.map((auditor) => (
                              <option key={auditor.id} value={getAuditorDisplayName(auditor)}>{getAuditorDisplayName(auditor)}</option>
                            ))}
                          </select>
                        )
                      ) : key === 'secondaryAuditorName' ? (
                        showNoAuditorsMessage ? (
                          <div className="no-data">No {campaign?.auditType} auditors available with matching skills</div>
                        ) : (
                          <select value={getCurrentSecondaryAuditorName()} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input" disabled={isAuditorFieldDisabled} title={isAuditorFieldDisabled ? "Please save the checklist first before assigning auditors" : ""}>
                            <option value="">Select Secondary Auditor</option>
                            {availableSecondaryAuditors.length > 0 && availableSecondaryAuditors.map((auditor) => (
                              <option key={auditor.id} value={getAuditorDisplayName(auditor)}>{getAuditorDisplayName(auditor)}</option>
                            ))}
                          </select>
                        )
                      ) : key === 'assignedCheckList' ? (
                        filteredChecklists.length > 0 ? (
                          <select value={value || ''} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input" >
                            <option value="">Select Checklist</option>
                            {filteredNormalChecklists.length > 0 && (
                              <optgroup label="Normal Checklists">
                                {filteredNormalChecklists.map((item) => (
                                  <option key={item.baseTemplateId} value={item.templateName}>{item.templateName}</option>
                                ))}
                              </optgroup>
                            )}
                            {filteredIntegratedChecklists.length > 0 && (
                              <optgroup label="Integrated Checklists">
                                {filteredIntegratedChecklists.map((item) => (
                                  <option key={item.baseTemplateId} value={item.templateName}>{item.templateName} (Integrated)</option>
                                ))}
                              </optgroup>
                            )}
                          </select>
                        ) : (
                          <div className="no-data">{showNoChecklistsMessage}</div>
                        )
                      ) : key === 'remarkByQC' ? (
                        <textarea value={value || ""} onChange={(e) => handleRestrictedTextareaChange(e.target.value, (val) => handleFieldChange(key, val))} className="edit-input" required />
                      ) : (
                        <input type="text" value={value || ""} onChange={(e) => handleFieldChange(key, e.target.value)} className="edit-input" />
                      )
                      ) : (value || "N/A")
                    }
                      icon={<IconComponent name={key} />}
                    />
                  );
                })}
              {isAdminOrQC && campaign.auditStatus === "NOT_STARTED" &&
                (campaign.itemStatus === "AUTO_INCLUDED" || campaign.itemStatus === "FINAL_INCLUDED") &&
                displayFields.filter(([key]) => !editableFields.includes(key)).length > 0 && (
                  <h3 className="editfield">Non Editable Fields</h3>
                )}
              {displayFields
                .filter(([key]) => !editableFields.includes(key))
                .map(([key, value]) => (
                  <Card key={key} label={key.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())} value={value || "N/A"} icon={<IconComponent name={key} className="icon" />} />
                ))}
            </>
          )}
        </div>
      )}
      <div className="buttons">
        <BackButton className="back-button2" label="Back" />
      </div>
      {showIncludeConfirmation && (
        <div className="review-overlay">
          <div className="review-content">
            <h3>Include Project</h3>
            <p>Please provide comments for including this project:</p>
            <textarea value={remark} onChange={(e) => handleRestrictedTextareaChange(e.target.value, setRemark)} placeholder="Enter your comments here..." rows={4} required />
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setShowIncludeConfirmation(false)}>Cancel</button>
              <button className="savebutton" onClick={confirmAction}>Confirm</button>
            </div>
          </div>
        </div>
      )}
      {showExcludeConfirmation && (
        <div className="review-overlay">
          <div className="review-content">
            <h3>Exclude Project</h3>
            <p>Please provide comments for excluding this project:</p>
            <textarea value={remark} onChange={(e) => handleRestrictedTextareaChange(e.target.value, setRemark)} placeholder="Enter your comments here..." rows={4} required />
            <div className="buttons">
              <button className="cancelbutton" onClick={() => setShowExcludeConfirmation(false)}> Cancel</button>
              <button className="savebutton" onClick={confirmAction}> Confirm </button>
            </div>
          </div>
        </div>
      )}
      {showReschedulePopup && campaign && (
        <RescheduleMeetingPopup handleClose={handleCloseReschedulePopup} handleSubmit={handleRescheduleSubmit} campaignDetails={campaign} />
      )}
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
    </div>
  );
};
export default CampaignDetailsInfo;